import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'

export default {
  async getAll (context) {
    const states = await api.states.getAll()

    Logger.info('Got all states')
    Logger.debug(states)

    context.commit('getAllStates', states)

    return states
  }
}
